class PlasticControl {
  addControl() {
    const containerId = 'layers-controls';
    this._container = document.getElementById(containerId) || document.createElement('div');
    this._container.id = containerId;

    this._el = document.createElement('button');
    this._el.className = 'plastic-icon';
    this._el.dataset.layoutPropertyIds = 'plastic';
    this._el.title = 'Plastic';
    this._container.appendChild(this._el);
    this._el.addEventListener('click', this.onClick.bind(this));
    return this._container;
  }


  onAdd(map) {
    this._map = map;
    return this.addControl();
  }

  onClick() {
    // Get all custom layout property IDs from each button dataset
    // Deactivate all other custom layers
    const customLayoutPropertyIds = Array.from(this._container.children)
      .forEach(el => {
        el.classList.remove('active');
        el.dataset.layoutPropertyIds.split(' ').forEach(id => {
          if (id !== 'plastic') {
            if (this._map.getLayer(id)) {
              this._map.setLayoutProperty(id, 'visibility', 'none');
            }
            Array.from(document.querySelectorAll(`.${id}`))
              .forEach(item => item.style.display = 'none');
          }
        });
      });
    const plasticVisible = this._map.getLayoutProperty('plastic', 'visibility') === 'visible';
    this._el.classList.toggle('active', !plasticVisible);
    this._map.setLayoutProperty('plastic', 'visibility', plasticVisible ? 'none' : 'visible');
  }

  onRemove() {
    this._container.removeChild(this._el);
    this._el = undefined;
    this._map = undefined;
  }
}

export default PlasticControl;
